let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("1R1T9")).then(() => parcelRequire('chIH8'));